if (!customElements.get('product-delivery-message')) {
  class ProductDeliveryMessage extends HTMLElement {
    connectedCallback() {
      this.renderDeliveryDate();

      if (this.querySelector('[data-delivery-config]')) {
        this.refreshTimer = window.setInterval(() => {
          this.renderDeliveryDate();
        }, 60000);
      }
    }

    disconnectedCallback() {
      if (this.refreshTimer) {
        window.clearInterval(this.refreshTimer);
      }
    }

    getAmsterdamNow() {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Amsterdam',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());

      const values = {};

      parts.forEach((part) => {
        if (part.type !== 'literal') {
          values[part.type] = part.value;
        }
      });

      const year = Number(values.year);
      const month = Number(values.month);
      const day = Number(values.day);
      const hour = Number(values.hour);
      const minute = Number(values.minute);

      return {
        year,
        month,
        day,
        hour,
        minute,
        weekday: new Date(
          Date.UTC(year, month - 1, day, 12)
        ).getUTCDay()
      };
    }

    parseCutoff(value) {
      const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(
        String(value || '')
      );

      return match
        ? (Number(match[1]) * 60) + Number(match[2])
        : null;
    }

    addCalendarDays(now, days) {
      return new Date(
        Date.UTC(
          now.year,
          now.month - 1,
          now.day + Number(days || 0),
          12
        )
      );
    }

    formatDate(date, format) {
      const options =
        format === 'complete'
          ? {
              weekday: 'long',
              day: 'numeric',
              month: 'long',
              timeZone: 'UTC'
            }
          : {
              weekday: 'short',
              day: 'numeric',
              month: 'short',
              timeZone: 'UTC'
            };

      return new Intl.DateTimeFormat('nl-NL', options).format(date);
    }

    renderDeliveryDate() {
      const configElement = this.querySelector(
        '[data-delivery-config]'
      );

      const dateElement = this.querySelector(
        '[data-delivery-date]'
      );

      if (!configElement || !dateElement) {
        return;
      }

      let config;

      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        console.warn(
          'Bezorgmelding: ongeldige configuratie.',
          error
        );
        return;
      }

      const now = this.getAmsterdamNow();
      const schedule = config.days?.[now.weekday];

      if (!schedule) {
        return;
      }

      let deliveryDays = schedule.primaryDays;

      if (schedule.useCutoff) {
        const cutoffMinutes = this.parseCutoff(
          schedule.cutoff
        );

        const currentMinutes =
          (now.hour * 60) + now.minute;

        if (
          cutoffMinutes !== null &&
          currentMinutes >= cutoffMinutes
        ) {
          deliveryDays = schedule.afterDays;
        }
      }

      const deliveryDate = this.addCalendarDays(
        now,
        deliveryDays
      );

      dateElement.textContent = this.formatDate(
        deliveryDate,
        config.dateFormat
      );
    }
  }

  customElements.define(
    'product-delivery-message',
    ProductDeliveryMessage
  );
}